import React               from 'react'
import prettysize          from '../../utils'
import moment              from 'moment'
import { Tooltip, Button } from 'antd'
import BullhornIcon        from '../../assets/img/bullhorn-font-awesome.png'
import EmptyState          from '../Shared/EmptyState'
import './storage-list.scss'

export default ({storages, history, on_refresh, refreshing, cloud={}}) => {
  return (
    (!storages || storages.length === 0) ?
      <EmptyState title={cloud.account_type_id === 'aws' ? 'We are gathering your account data'
        :`Congrats on setting up new
         ${cloud.account_type_id.charAt(0).toUpperCase()
           + cloud.account_type_id.slice(1)} Storage!`}
                  description={
                    cloud.account_type_id === 'aws'?
                      'Please allow just a little time for us to aggregate your data':
                      'Cloud account is empty\n' +
                      'Please add a bucket'
                  }
                  click_text='refresh'
                  on_click={on_refresh}
      /> :
      <div className='storage-list'>
        <div className='header'>
          <p>Name</p>
          <p>Region</p>
          <p>Created</p>
          <p>Usage</p>
          {/*<p>Costs</p>*/}
          {/* <p>Actions</p> */}
          <Tooltip title={'refresh buckets list'}>
            <Button onClick={e=>{
              e.stopPropagation()
              on_refresh()
            }} type="primary" loading={refreshing} shape="circle" icon="sync" size={'small'}/>
          </Tooltip>
        </div>
        {storages.map((storage, i) => !storage.hidden && <Storage key={i} storage={storage} history={history} />)}
      </div>
  )
}

const Storage = ({ storage, history }) => (
  <div className='row'>
    <Tooltip title={storage.bucket_name}>
      <p className={'bucket_name'}>{storage.bucket_name}</p>
    </Tooltip>

    <Tooltip title={storage.region}>
      <p className={'bucket_region'}>{storage.region}</p>
    </Tooltip>

    <Tooltip title={moment(storage.created_on).format('MM/DD/YYYY')}>
      <p>{moment(storage.created_on).format('MM/DD/YYYY')}</p>
    </Tooltip>

    <Tooltip title={prettysize(storage.size)}>
      <p className='usage success'>{prettysize(storage.size)}</p>
    </Tooltip>

    {/*<Tooltip title={'$' + (storage.cost ? storage.cost.toFixed(3) : 0)}>
      <p>${storage.cost ? storage.cost.toFixed(3) : 0}</p>
    </Tooltip>*/}

    {/* <RowActions history={history} storage={storage} /> */}

    <div/>
  </div>
)

const RowActions = ({ history, storage }) => (
  <p className='row-actions'>
    <Tooltip title='Set Notifications'>
      <img
        src={BullhornIcon} alt=''
        onClick={e => {
          e.stopPropagation()
          history.push('/setAlert/' + storage.id)
        }}
      />
    </Tooltip>
    {/* <Tooltip title='edit'>
      <img src={PencilIcon} alt='' />
    </Tooltip> */}
    {/*<Tooltip title='delete'>
      <img src={TrashIcon} alt='' />
    </Tooltip>*/}
    {/* <Tooltip title='share'>
      <img src={ShareIcon} alt='' />
    </Tooltip> */}
  </p>
)
